import { useContext } from 'react'
import { PaymentContext } from '../../../store/PaymentContext'

// TODO: Move Octopus payment related from payment.jsx to here

const payByOctopus = (price) => {
    console.log(`Pay $${price} by Octopus`)
}

export default function OctopusPaymentBadge(props) {
    const disabled = props.disabled
    const { state: paymentState, dispatch: paymentDispatch } = useContext(PaymentContext);
    return (
        <>
            <button
                onClick={() => {
                    console.log('payByOctopus', paymentState)
                    paymentDispatch({
                        type: 'update',
                        payload: {
                            paymentType: 'octopus',
                            paymentStatus: 'PENDING',
                            paymentStatusDesc: 'Payment pending',
                            paymentGatewayDetails: null
                        }
                    })
                }}
                className="btn btn-primary btn-light payBtn-airwallex px-4 py-2 fw-bold bg-white"
                style={{
                    width: '35%'
                }}
                disabled={disabled}
            // className="d-none"
            >
                {/* Pay by Octopus */}
                <img
                    src="logo/octopus.png"
                    alt="Pay by Octopus"
                    style={{
                        maxWidth: '100%',
                    }}
                />
            </button >
        </>
    )
}